import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import wixData from 'wix-data';

const createHtml = (text, url, extraStyle) => `<h2 style="font-size:15px"><span style="font-size:15px"><span style="font-family:wfont_311dce_37a69b3a7ca14f258c3442f95b081dd3,wf_37a69b3a7ca14f258c3442f95,orig_helvetica_neue_w_01_55_roman;border-bottom-width: 1px;border-bottom-style: solid;padding-bottom: 3px;${extraStyle}"><a href="${url}" target="_self">${text}</span></span></a></h2>`;
const regularHtml = (text, url) => createHtml(text, url, '');
const hoverHtml = (text, url) => createHtml(text, url, 'color: #0067ff;');

$w.onReady(function () {

    createDropDownValues()

    let formFactor = wixWindow.formFactor;
    // if (formFactor !== "Mobile") {
    // 	$w('#group1').hide();
    // }

    $w('#pressRepeater').onItemReady(($item, itemData, index) => {
        // console.log(itemData.arical)
        let countSlash = 0
        let countSlashEnd
        let countSlashStart
        for (let x = 0; x < itemData.arical.length; x++) {
            if (itemData.arical[x] === "/") {
                countSlash++
                countSlashEnd = x
                if (countSlash === 4) {
                    countSlashStart = x
                }
            }
        }
        let resultArical = itemData.arical.slice(countSlashStart, countSlashEnd);
        let pdfTemp = "https://eeb28f5d-cf46-4b84-8e45-05c5a6595a83.filesusr.com/ugd" + resultArical
        $item("#buttonPdf").link = pdfTemp
        $item("#text55").text = textShortening(itemData)
        // const text1 = $item('#itemBtLabel');
        // text1.html = regularHtml(text1.text, itemData.url);

        // $item('#itemBtn').onClick(() => {
        // 	wixLocation.to(itemData.url)
        // })

        $item('#itemBtn').onMouseIn(() => {
            // text1.html = hoverHtml(text1.text, itemData.url);
        });

        $item('#itemBtn').onMouseOut(() => {
            // text1.html = regularHtml(text1.text, itemData.url);
        });
    });

    $w('#loadMoreButton').onClick(() => {
        $w("#pressDataset").onReady(() => {
            $w("#pressDataset").loadMore()
        });
    })
});

export function searchBar_keyPress(event) {
    if (!$w('#searchBar').value) {
        $w('#pressDataset').setFilter(wixData.filter())
    } else {
        $w("#pressDataset").setFilter(wixData.filter()
            .contains("subTitle", $w("#searchBar").value)
            .or(wixData.filter()
                .contains("title", $w('#searchBar').value)))
    }
}

export function yearsDropdown_change(event) {
    if ($w('#yearsDropdown').value === "すべて") {
        $w('#pressDataset').setFilter(wixData.filter())
    } else {
        $w('#pressDataset').setFilter(wixData.filter()
            .eq("year", $w('#yearsDropdown').value))
    }
}

function textShortening(itemData) {
    let fullText = itemData.title;
    let text2Show
    if (fullText.length >= 85) {
        text2Show = fullText.slice(0, 85) + "..."
        return text2Show;
    }
    return fullText;
}

function createDropDownValues() {
    wixData.query("PressReleases")
        .limit(1000)
        .find()
        .then(results => {
            let dropDownValues = [];
            results.items.forEach(item => {
                if (dropDownValues.indexOf(item.year) === -1) {
                    dropDownValues.push(item.year)
                }
            })
            dropDownValues.sort().reverse()
            dropDownValues.unshift('すべて')
            $w("#yearsDropdown").options = dropDownValues.map(item => {
                return { "label": item, "value": item }
            });
        })
}

const slideOptions = {
    direction: 'right',
    duration: 300
};

export function siteSearchIcon_click(event, $w) {
    if ($w('#searchBar').hidden) {
        $w('#searchBar').show('slide', slideOptions);
        setTimeout(() => {
            $w('#searchBar').focus();
        }, 350);
        return;
    }
    $w('#searchBar').hide('slide', slideOptions);
}